module.exports = __webpack_public_path__ + "media/packs/images/state/inland-88e58cb35042b3becd5aa331efec2c4e.svg";